module.exports = __webpack_public_path__ + "img/credit_visa_icon.5dfa642e.png";